import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { TagData } from 'globals/store/tags.data';
import { TagsComponent } from '../manage/tags.component';

@Component({
    selector: 'on-sessions-view',
    template: `
<tags 
  [noTitle]="true"
  [tags]="tags"
  [emptyText]="'No sessions added'"
  [readOnly]="readOnly"
  [tagText]="'+ Add a Session'"
  (remove)="remove.emit($event)"
  (open)="open.emit($event)"
></tags>
`,
    styleUrls: [],
    standalone: true,
    imports: [TagsComponent],
})
export class OnSessionsViewComponent {
  @Input() readOnly
  @Input() tags: TagData[] = []
  @Output() remove: EventEmitter<string> = new EventEmitter()
  @Output() open: EventEmitter<any> = new EventEmitter()
}

